import { t } from "../lib/sprache";

/** Datensatz aus den Beispieldaten des Schnellstarts (0325: Spalte is_sample an Creator, Marke, Kooperation, Vertrag, Rechnung) */
export function istBeispiel(x: object | null | undefined): boolean {
  return !!x && (x as { is_sample?: unknown }).is_sample === true;
}

/** Etikett „Beispiel“ an Zeilen und Köpfen mit Beispieldaten (senden nichts, zählen nicht in den Tarif) */
export function BeispielEtikett({ von }: { von: object | null | undefined }) {
  if (!istBeispiel(von)) return null;
  return <span className="pill info tk-beispiel-etikett" title={t("Beispieldaten: senden nichts, zählen nicht in deinen Tarif", "Sample data: sends nothing, does not count towards your plan")}>{t("Beispiel", "Sample")}</span>;
}
